export default "__VITE_ASSET__BM82PMZl__"